module.exports = __webpack_public_path__ + "img/jianjie2.493b853a.jpg";